import { scrollToSection, scrollToTop } from "../../lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <button type="button" onClick={scrollToTop} data-testid="footer-logo-btn" className="flex items-center gap-4 mb-4">
              <img src="/bigibila-logo.png" alt="Bigibila Research" data-testid="footer-logo" className="h-16 w-16" />
              <img src="/governance-before-data-wheel.png" alt="Governance before Data wheel" data-testid="footer-wheel" className="h-11 w-11" />
              <p className="font-serif text-3xl">Bigibila Research</p>
            </button>
            <p className="text-sm text-stone2 leading-relaxed max-w-md">
              First Nations-led research and consulting in governance, authority
              and Indigenous Data Sovereignty. Governance before data.
            </p>
          </div>
          <div className="md:col-span-3 font-mono text-xs text-stone2 space-y-2">
            <p>research@bigibila.com.au</p>
            <p>liana@bigibila.com.au</p>
            <p>0466 943 229</p>
          </div>
          <div className="md:col-span-3 md:text-right font-mono text-[11px] uppercase tracking-[0.2em] text-stone2 space-y-2">
            <p>© {new Date().getFullYear()} Bigibila Consultancy</p>
            <p><button type="button" onClick={() => scrollToSection("briefing")} data-testid="footer-briefing-link" className="hover:text-ember transition-colors duration-300">Request a Confidential Briefing</button></p>
            <p><button type="button" onClick={() => scrollToSection("contact")} data-testid="footer-contact-link" className="hover:text-ember transition-colors duration-300">Contact</button></p>
          </div>
        </div>
        <div className="quill-rule mt-12" />
        <p data-testid="ip-notice" className="font-mono text-[11px] text-stone2 mt-6 leading-relaxed max-w-4xl">
          © 2026 Bigibila IP Holdings Pty Ltd. All rights reserved.
          Bigibila Governance Archaeology™, Bigibila Advisory Method™, QUILL™
          and associated frameworks, analytical instruments, terminology,
          visual architecture, scoring systems, implementation protocols and
          outputs are proprietary intellectual property and sovereign
          Yuwaalaraay–Gamilaraay assets. The Bigibila codebook and internal
          methodology are never disclosed or licensed. No reproduction,
          adaptation, extraction, reverse engineering, automated ingestion,
          training or derivative use is permitted without prior written
          authorisation. Cultural knowledge remains subject to cultural
          authority, ICIP protocols and permissions.
        </p>
        <p className="font-mono text-[11px] text-stone2 mt-4 leading-relaxed max-w-4xl">
          We acknowledge the Traditional Owners of Country throughout Australia
          and pay respect to Elders past and present.
        </p>
      </div>
    </footer>
  );
}
